export interface PDF {
  filename: string;
  loaderColor: string;
  pageBackground: string;
  pdfHeight: number;
  pdfWidth: number;
}

const pdfs: Record<string, PDF> = {
  "shiftime-case-study": {
    filename: "shiftime-case-study.pdf",
    pageBackground: "#1A1F2D",
    loaderColor: "#87B9FF",
    pdfWidth: 1440,
    pdfHeight: 900,
  },
  "likuid-proposal": {
    filename: "likuid-proposal.pdf",
    pageBackground: "#1A1F2D",
    loaderColor: "#87B9FF",
    pdfWidth: 1440,
    pdfHeight: 1024,
  },
  offer: {
    filename: "offer.pdf",
    pageBackground: "#1A1F2D",
    loaderColor: "#87B9FF",
    pdfWidth: 1440,
    pdfHeight: 900,
  },
  "offer-b": {
    filename: "offer-b.pdf",
    pageBackground: "#1A1F2D",
    loaderColor: "#87B9FF",
    pdfWidth: 1440,
    pdfHeight: 900,
  },
};

export default pdfs;
